import { Form, FormInstance, Row } from "antd";
import { useCallback, useState } from "react";
import { useFetchPrimaryData } from "../hooks/useFetchPrimaryData";
import { SendToFormItem } from "./SendToFormItem";
import { SubjectRow } from "./SubjectRow";
import { Message } from "./Message";
import { Attachments } from "./Attachments";
import { Loader } from "./Loader";
import { IPrimaryData } from "../../../types/PrimaryData";
import { useInitialValues } from "../hooks/useInitialValues";

type FormContainerProps = {
  contractId: string;
  form: FormInstance;
  primaryData: IPrimaryData;
  sendToData: any[];
  isLoading: boolean;
  setIsLoading: React.Dispatch<React.SetStateAction<boolean>>;
  setSendToData: React.Dispatch<React.SetStateAction<any[]>>;
  clearError: () => void;
};

export const FormContainer = ({
  contractId,
  form,
  primaryData,
  sendToData,
  isLoading,
  setIsLoading,
  setSendToData,
  clearError,
}: FormContainerProps) => {
  const [isTemplateGenerating, setIsTemplateGenerating] =
    useState<boolean>(false);

  const setGlobalIsLoading = useCallback(
    (value: boolean) => {
      setIsTemplateGenerating(value);
      setIsLoading(value);
    },
    [setIsLoading],
  );

  const { formattedData: initalData } = useFetchPrimaryData(
    primaryData,
    setIsLoading,
  );

  const { initialValues } = useInitialValues();

  return (
    <Row className="d-block position-relative">
      <Form
        form={form}
        autoComplete="off"
        layout="vertical"
        requiredMark={false}
        disabled={isLoading}
        initialValues={initialValues}
        onChange={clearError}
        className={isTemplateGenerating ? "blured" : ""}
      >
        <SendToFormItem
          form={form}
          initalData={initalData}
          optionsData={sendToData}
          setOptionsData={setSendToData}
          clearError={clearError}
        />

        <SubjectRow
          form={form}
          contractId={contractId}
          isLoading={isLoading}
          clearError={clearError}
          setGlobalIsLoading={setGlobalIsLoading}
        />

        <Message />

        <Attachments clearError={clearError} setIsLoading={setIsLoading} />
      </Form>
      {isTemplateGenerating && <Loader />}
    </Row>
  );
};
